import { getCurrencyParts } from './formatCurrency';

/**
 * Trims a preset amount's fraction portion if it has more digits than allowed by the currency.
 */
export function trimAmountForCurrency(amount, currencyCode, locale) {
  const amountParts = getCurrencyParts({
    amount,
    locale,
    currencyCode,
    options: {
      trailingZeroDisplay: 'stripIfInteger'
    }
  });
  const decimalSymbol = amountParts.find(part => part.type === 'decimal')?.value || '';
  const trimmedAmount = amountParts.filter(part => ['integer', 'decimal', 'fraction'].includes(part.type)).map(part => part.value).join('');
  if (decimalSymbol === ',') {
    return Number(trimmedAmount.replace(',', '.'));
  }
  return Number(trimmedAmount);
}